import type { LucideIcon } from 'lucide-react';
import { Inbox } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  /** Дія (кнопка) — порожній стан завжди підказує, що робити далі (CONVENTIONS §3). */
  action?: ReactNode;
  /** Компактний варіант усередині таблиці / картки. */
  compact?: boolean;
  tone?: 'neutral' | 'danger';
  className?: string;
}

export function EmptyState({ icon: Icon = Inbox, title, description, action, compact, tone = 'neutral', className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center', compact ? 'gap-2 px-4 py-8' : 'gap-3 px-6 py-14', className)}>
      <span
        className={cn(
          'flex items-center justify-center rounded-card',
          compact ? 'size-10' : 'size-12',
          tone === 'danger' ? 'bg-danger-soft text-danger' : 'bg-surface-3 text-muted',
        )}
        aria-hidden
      >
        <Icon className={compact ? 'size-5' : 'size-6'} />
      </span>
      <div className="max-w-md">
        <p className={cn('font-semibold', compact ? 'text-[14px]' : 'text-[16px]')}>{title}</p>
        {description ? <p className="mt-1 text-[13px] text-muted">{description}</p> : null}
      </div>
      {action ? <div className="mt-1 flex flex-wrap items-center justify-center gap-2">{action}</div> : null}
    </div>
  );
}
